import { ArrowRight } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg?auto=compress&cs=tinysrgb&w=1600"
          alt="Corporate team"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-navy-900/70"></div>
      </div>
      
      {/* Content */}
      <div className="container-custom relative z-10 text-white">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-tight">
            Membangun masa depan yang lebih cerah melalui solusi tenaga kerja berkualitas.
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            CV Samudera Alam Perkasa adalah mitra tepercaya untuk solusi kebutuhan tenaga kerja profesional di Indonesia.
          </p>
          <div className="flex flex-wrap gap-4">
            <NavLink to="/contact" className="btn btn-primary">
              Hubungi Kami
            </NavLink>
            <NavLink to="/services" className="btn btn-outline border-white text-white hover:bg-white hover:text-navy-900">
              <span>Lihat Layanan</span>
              <ArrowRight size={20} className="ml-2" />
            </NavLink>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce bg-white p-2 w-10 h-10 ring-1 ring-white/20 shadow-lg rounded-full flex items-center justify-center">
          <svg className="w-6 h-6 text-navy-900" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;